import React from 'react';
import { IDowntime, ILabel, convertApiDate, formatDate, formatTripsAmountLabel, getLabelValue } from '@adac-mp/shared';
import { Blocked, South, Typography } from '../../index';

interface ITollSectionInfo {
	downtimes?: IDowntime[];
	routeDirection?: string;
	sectionName?: string;
	trips?: number;
	labels: ILabel[] | undefined;
	moduleTypeId?: number;
}

export const TollSectionInfo = ({
	downtimes,
	routeDirection,
	sectionName,
	trips,
	moduleTypeId,
	labels,
}: ITollSectionInfo) => {
	const isTollSection = moduleTypeId === 3;
	return (
		<>
			{downtimes &&
				downtimes.length > 0 &&
				downtimes[0].type === 'warn' &&
				downtimes.map(({ id, usageFrom, usageTo }) => (
					<Typography key={id} className="flex items-center gap-1.5" color="lightText">
						<Blocked className="inline-flex self-baseline" />
						{`${getLabelValue('mp.streckeGesperrt', labels) || 'Strecke gesperrt'} ${formatDate(
							convertApiDate(usageFrom),
						)} – ${formatDate(convertApiDate(usageTo))}`}
					</Typography>
				))}
			{routeDirection && (
				<Typography className="flex items-center gap-1.5" color="lightText">
					<South className="inline-flex self-baseline" />
					{routeDirection}
				</Typography>
			)}
			{isTollSection && trips && (
				<Typography color="title">
					{sectionName && `${sectionName}, `}
					{formatTripsAmountLabel(trips, labels)}
				</Typography>
			)}
		</>
	);
};
